import React from 'react';
import { Section } from './ui/Section';
import { BundleCard } from './BundleCard';
import { Timer } from 'lucide-react';
import { OfferCountdown } from './OfferCountdown';
export function PricingBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const checkoutUrls: Record<number, string> = {
    1: 'https://glowliftessencemx.com/checkouts/cn/hWN7vOYAJq4UueGCZ8EahjAw/es-es?_r=AQAByo6pCPRmnPWoIF9CBBWWKGiqUTz4FEuvdd6aHwYtPv0&preview_theme_id=184489181460&skip_shop_pay=true',
    2: 'https://glowliftessencemx.com/checkouts/cn/hWN7vOcoJTOnICTIKTciEyDS/es-es?_r=AQABBx6lFQnLZJjNE6ZusdHf1_gZc3vt67IUUFSXtIJxajw&preview_theme_id=184489181460&skip_shop_pay=true',
    3: 'https://glowliftessencemx.com/checkouts/cn/hWN7vOemwHVdFOeil2gWtqoE/es-es?_r=AQABMucCgwqDR0-0opQWwjXdRRl6MSTPEpg6tgeDm30xBMQ&preview_theme_id=184489181460&skip_shop_pay=true',
    6: 'https://glowliftessencemx.com/checkouts/cn/hWN7vOhKU6KZIlXQGTVBavg2/es-es?_r=AQABNccSApF-lpEw1M2oEGLI0dRI1IlOsSg_CaBUOV6RxLU&preview_theme_id=184489181460&skip_shop_pay=true'
  };
  const bundles = [{
    quantity: 1,
    price: '34,95 €',
    originalPrice: '49,95 €',
    savings: 30,
    bonuses: ['E-book Gratis: Guía Detox Natural'],
    productImage
  }, {
    quantity: 2,
    price: '54,95 €',
    originalPrice: '79,95 €',
    savings: 31,
    bonuses: ['E-book Gratis: Guía Detox Natural'],
    productImage
  }, {
    quantity: 3,
    price: '64,95 €',
    originalPrice: '99,95 €',
    savings: 35,
    isBestValue: true,
    bonuses: ['E-book Gratis: Guía Detox Natural'],
    productImage
  }, {
    quantity: 6,
    price: '99,95 €',
    originalPrice: '159,95 €',
    savings: 38,
    bonuses: ['E-book Gratis: Guía Detox Natural'],
    productImage
  }];
  return <Section id="pricing" className="pt-12" data-id="element-268">
      <div className="text-center mb-12" data-id="element-269">
        <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-4 py-2 rounded-full text-sm font-bold mb-4" data-id="element-270">
          <Timer className="w-4 h-4" data-id="element-271" />
          Oferta por Tiempo Limitado
        </div>

        <OfferCountdown data-id="element-272" />

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-273">
          Elige tu Pack y Empieza Hoy
        </h2>
        <p className="text-gray-600 text-lg mb-2" data-id="element-274">
          El 78% de nuestras clientas eligen el pack de 3 meses para resultados
          óptimos.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 bg-[#D4AF37]/10 text-[#2D5016] px-4 py-2 rounded-full" data-id="element-275">
          <span className="text-2xl" data-id="element-276">📚</span>
          <span className="font-bold" data-id="element-277">
            E-book GRATIS incluido en todos los packs
          </span>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 items-end" data-id="element-278">
        {bundles.map((bundle, i) => <BundleCard key={i} {...bundle} onSelect={() => {
        const url = checkoutUrls[bundle.quantity];
        if (url) {
          window.location.href = url;
        }
      }} data-id="element-279" />)}
      </div>

      <div className="mt-12 text-center" data-id="element-280">
        <p className="text-xs text-gray-400 mt-4 max-w-2xl mx-auto" data-id="element-281">
          *Los resultados pueden variar de una persona a otra. Este producto no
          está destinado a diagnosticar, tratar, curar o prevenir ninguna
          enfermedad. Complemento a una dieta equilibrada y ejercicio.
        </p>
      </div>
    </Section>;
}